import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], term): any {
    return term ? items.filter(item => item.title.indexOf(term) !== -1) : items;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/search-filter.pipe.ts